import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const Permissions = () => {

    const [permissionsList, setPermissionsList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [intPermissionId, setIntPermissionId] = useState("");
    const [permissionName, setPermissionName] = useState("");
    const [permissionsKeyName, setPermissionsKeyName] = useState("");
    const [permissionStatus, setPermissionStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchPermission();
    }, [])

    async function fetchPermission() {
        setIsLoading(true);
        const permResponse = await func.listPermission();
        setPermissionsList(Array.isArray(permResponse) ? permResponse : [])
        setIsLoading(false);
    }

    const filteredData = permissionsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const permissionRender = (rowData) => {
        return <span>{rowData.permissionName}</span>;
    };

    const permissionKeyNameRender = (rowData) => {
        return <span>{rowData.permissionKeyName}</span>;
    };

    const permissionStatusRender = (rowData) => {
        return <span>{(rowData.permissionStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editPermission(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const permId = rowData.permissionId;

        return (
            <Link to="#" onClick={() => deletePermission(permId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newPermission() {
        setIsEdit(false)
        setOpenModal(true)
        setIntPermissionId("");
        setPermissionName("");
        setPermissionsKeyName("");
        setPermissionStatus("");
    }


    async function editPermission(rowData) {
        const permId = rowData.permissionId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.getPermission(permId);
        setIntPermissionId(getDetails.permissionId);
        setPermissionName(getDetails.permissionName);
        setPermissionsKeyName(getDetails.permissionKeyName);
        setPermissionStatus(getDetails.permissionStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updatePermission();
            } else {
                if (permissionName && permissionsKeyName) {
                    const formData = new FormData();
                    formData.append("permissionsName", permissionName);
                    formData.append("permissionsKeyName", permissionsKeyName);

                    const createPermission = api.AddPermission;
                    fetch(createPermission, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // window.location.reload(); // 🔁 Reload only after OK is clicked
                                        setOpenModal(false);
                                        fetchPermission();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updatePermission() {
        const formData = new FormData();
        formData.append("permissionsName", permissionName);
        formData.append("permissionsKeyName", permissionsKeyName);
        formData.append("permissionsStatus", permissionStatus);

        const updatePermission = api.UpdatePermission + '/' + intPermissionId;
        fetch(updatePermission, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchPermission();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deletePermission(permId) {
        const deletePermission = api.DeletePermission + '/' + permId;
        fetch(deletePermission, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchPermission();
                        }
                    });
                    window.location.reload();
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Permissions</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newPermission() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Permission">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                                {/* </div> */}
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="permissionName"
                                                header="Permission Name"
                                                body={permissionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="permissionKeyName"
                                                header="Permissions Key Name"
                                                body={permissionKeyNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="permissionStatus"
                                                header="Permission Status"
                                                body={permissionStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Permission</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Permission Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="permissionName"
                                            value={permissionName}
                                            onChange={(e) => setPermissionName(e.target.value)}
                                            placeholder="Permission Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Permission Key Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="permissionKeyName"
                                            value={permissionsKeyName}
                                            onChange={(e) => setPermissionsKeyName(e.target.value)}
                                            placeholder="Permission Key Name" />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={permissionStatus === '1'}
                                                        id="permissionStatus"
                                                        onChange={(e) => {
                                                            setPermissionStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default Permissions;